import React from 'react';
//import  RelatedPosts from '../../Related/RelatedPosts'

export const PostFeed = (props) => {
  return null;
  //return <RelatedPosts {...props} />
}
